import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePagePermissions } from '../hooks/usePagePermissions';
import { useAuth } from '../contexts/AuthContext';
import AccessDenied from './AccessDenied';

const ProtectedPageRoute = ({ pageName, children }) => {
  const { user } = useAuth();
  const { canViewPage, loading } = usePagePermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'admin') {
    return children;
  }

  if (!canViewPage(pageName)) {
    return <AccessDenied pageName={pageName} />;
  }

  return children;
};

export default ProtectedPageRoute;
